import {BrowserModule, Title} from '@angular/platform-browser';
import {Injectable, NgModule} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpResponse} from '@angular/common/http';

import { Observable, throwError } from "rxjs";
import { catchError, map } from 'rxjs/operators';

import { BillingModule } from 'app/billing/billing.module';
import { UserModule } from 'app/user/user.module';
import { SupportModule } from 'app/support/support.module';

import {MenuComponent} from "app/menu/menu.component";
import {EventsService } from "app/lib/EventsService";
import {RoutingModule} from "app/routing.module";

import {HTTP_INTERCEPTORS, HttpClientModule, HttpErrorResponse, HttpInterceptor} from '@angular/common/http';
import { NavigationEnd, Router } from "@angular/router";
import {DomainsModule} from "./domains/domains.module";
import {HelperService} from "./lib/helper.service";
import {MenuModule} from "app/menu/menu.module";
import {TranslateService} from "./translate/translate.service";
import {getAdminMenuTree} from "app/lib/lib";

import {SitesModule} from "./sites/sites.module";
import {TemplateModule} from "./template/template.module";
import { WidgetModule } from "app/widget/widget.module";
import {AuthService} from "./auth.service";
import {IndexModule} from "./index/index.module";
import {TestModule} from "./test/test.module";
import {SimpleNotificationsModule} from 'angular2-notifications';

import {MailsModule} from "./mails/mails.module";
import {SupportService} from "./support/support/support.service";
import {ApiModule} from "./api/api.module";
import {FilterFormService} from "./views/filter_form/filter_form.service";
import {DataProvider} from "./provider/data.provider";
import { DataProvider2, DataProviderFactory } from "./provider/data2.provider";
import { SignInComponent } from './signIn/sign_in';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteProvider } from './provider/route.provider';
import { MetriksService } from './metriks.service';

import * as $ from 'jquery';
import * as moment from 'moment-timezone';
import { ObservaleQueue2 } from "./lib/ObservaleQueue2";
import * as dictionary from "../dict/static.json";

const config: any = dictionary['config'];

declare const window: any;

@Injectable()
export class JWTInterceptor implements HttpInterceptor {
	constructor(private eventsService: EventsService, private filterFormService: FilterFormService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const me = this;
		
		req = req.clone({
			setHeaders: {
				'X-Report-GUID': this.filterFormService.reportGUID
			},
		});

		const extractError = function (errorBody) {
			if (errorBody) {
				if (typeof (errorBody) === 'string') {
					return errorBody;
				} else {
					return JSON.stringify(errorBody);
				}
			}

			return 'unknow error!';
		};

		return next.handle(req).pipe(
			map((httpEvent: HttpEvent<any>) => {
				if (httpEvent instanceof HttpResponse) {
					const isUkitRequest = ! req.url.match(/\.js$/) && ! req.url.match(/\/api/);
					if (isUkitRequest && httpEvent.body[0]) {
						const errorText = extractError(httpEvent.body[0]);
						
						throw new Error(errorText);
					}
				}

				return httpEvent;
			}),
			catchError((httpError: HttpErrorResponse) => {
				let error;

				// Тут какая-то дичь с обработкой ошибки. И чуть выше, в next.handle(req).pipe - тоже обработка ошибки.
				// Подумать как улучшить
				if (/\/jwt/.test(httpError.url)) {
					error = new Error('Нет авторизации в ukit.com!');
				} else if (httpError.status) {
					if (httpError.status === 500) {
						error = new Error('server error');
					} else if (httpError.status === 403) {
						error = new Error('Нет доступа!');
					} else if (httpError.status === 404) {
						error = new Error('404 Not Found');
					} else if (httpError.status === 502) {
						error = new Error('Bad Gateway');
					} else if (httpError.status === 503) {
						error = new Error('Превышен интервал ожидания!');
					} else if (httpError.status === 504) {
						error = new Error('504 Gateway Time-out');
					} else {
						if(httpError.error[0]) {
							const errorText = extractError(httpError.error[0]);

							error = new Error(errorText);
						} else {
							error = new Error(`${httpError.status} ${httpError.statusText}`);
						}
					}
				} else {
					error = httpError;
				}

				me.eventsService.broadcast(
					'http-error',
					error
				);

				return throwError(error);
			})
		);
	}
}


@NgModule({
	declarations: [
		SignInComponent,
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		SimpleNotificationsModule.forRoot(),
		BillingModule,
		DomainsModule,
		UserModule,
		SupportModule,
		MenuModule,
		SitesModule,
		TemplateModule,
		WidgetModule,
		IndexModule,
		TestModule,
		MailsModule,
		ApiModule,
		RoutingModule,
	],
	providers: [
		HelperService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: JWTInterceptor,
			multi: true,
		},
		EventsService,
		AuthService,
		SupportService,
		DataProvider,
		DataProvider2,
		RouteProvider,
		MetriksService,
		DataProviderFactory,
		ObservaleQueue2,
	],
	entryComponents: [

	],
	exports: [

	],
	bootstrap: [
		MenuComponent
	]
})
export class AppModule {
	constructor(
		private router: Router,
		private translate: TranslateService,
		private titleService: Title,
	) {
		const me = this;
		
		window.$      = $;
		window.jQuery = $;
		moment.locale(
			translate.currentLang
		);
		
		// TODO Переписать это, крепко подумав зачем нам вообще нужен menu.component как точка входа всего рендера
		// По идеи должен быть некий app.component, который рендерит <router-outlet></router-outlet>.
		// А то сейчас это делает menu.component, да и показ title тоже не понятно где находится (пока ниже в app.module)
		const titleMap = {
			'/sign_in': 'Admin login page',
		};
		
		for(const menuNode of getAdminMenuTree()) {
			for(const submenuNode of menuNode.childs) {
				titleMap[submenuNode.route || submenuNode.url] = me.translate.__(submenuNode.i18n);
			}
		}
		
		me.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				let route = event.url;
				if (route.indexOf('?') > 0) {
					route = route.substring(0, route.indexOf('?'));
				}
				
				let title = 'statistics uKit';
				if (route && titleMap[route]) {
					title = titleMap[route] + ' uKit';
				} else if(route === 'support') {
					title = 'Support uKit';
				}
				
				me.titleService.setTitle(title);
			}
		});
	}
}
